<template>  
    <transition name="slide" class="simulatior-message">
      <div v-if="msgBoxState && msgBoxState != null" class="msgBoxContainer" draggable="true" @dragend="drag">
          <div class="msgBoxHeader">
            <img
              class="searchBt noselect"
              @click="ChangeSearchValue()"
              id="search-button"
              src="../../assets/buscar.png"
              title="Filtrar"
              alt="Filtrar mensagens"
            />
              <b :class="[{waiting: !isOnlineReady},{ready: isOnlineReady && !isOnlineRunning},{running: isOnlineRunning}]">
                  <span class="noselect spaceDrag" >Mensagens do On-line</span>
              </b>
            <span id="close-msg-box-bt" class="closeBoxBt noselect" @click="CloseMsgBox()">x</span>
          </div>

        <transition name="source">
          <div v-if="showSearchField" class="searchGroup">
            <div class="searchTitle noselect">Filtro: </div>
            <input class="searchInput" type="text" v-model="filter"/>
            <span class="clearSearchInputFilterBt noselect" @click="CleanInputFilter()">X</span>
          </div>
        </transition>
        <div :class="[{msxBoxTxtContainer: true, withSearch: showSearchField, withoutSearch: !showSearchField}]">
          <p id="msgBoxTxt" class="msgBoxTxt" v-for="(msg, index) in msgListFiltered" :key="index">{{msg.substring(0, 19)}} {{msg.substring(24)}}</p>
        </div>
      <span class="expand" 
      draggable="true"
      @drag="expandMove"
      @dragend="expandEnd"
      ><i class="bi bi-box-arrow-in-down-right"></i></span>
      </div>
    </transition>
</template>

<script>

  var taskGetSimulatorMessages;

  import { mapState } from "vuex";
  import { DragMixin } from "../mixins/dragMixin"
  import { urlMainAPI, showError } from "@/global";
  import axios from 'axios';

  export default {
    name: "SimulatorMessageBox",
    computed: mapState(["isOnlineReady", "isOnlineRunning", "msgBoxState", "user"]),
    mixins: [ DragMixin ],

    watch:{
      msgBoxState(newValue){
        if(newValue){
          clearTimeout(taskGetSimulatorMessages);
          this.StartGetSimulatorMessagesTask();
        }
        else{
          clearTimeout(taskGetSimulatorMessages);  
        }      
      },
      newValue() {
        this.ApplyFilter()
      },
      filter() {
        this.ApplyFilter()
      },
      msgList() {
        this.newValue += 1
      }
    },
    data: function() {
      return{
        showSearchField: false,
        filter: "",
        newValue: 0,
        msgList: [],
        msgListFiltered: [],
      }
    },
    methods: {
      async StartGetSimulatorMessagesTask() {
        await this.GetSimulatorMessages();
        taskGetSimulatorMessages = setTimeout(() => {
          this.StartGetSimulatorMessagesTask();
        }, 5000);
      },

      async GetSimulatorMessages(){
        if(this.user != null){
          let url = `${urlMainAPI}/getonlinesimulatormessages` 
          await axios.get(url).then((res)=>{
            this.msgList = res.data
            this.msgListFiltered = this.msgList
          })
          .catch(() => {
            showError(this.$t('falha-ao-obter-as-mensagens-do-simulador'))
          })          
        }
        return       
      },

      CloseMsgBox() {
        let div = document.querySelector('.msgBoxContainer')
        if(div)
          div.style.display = 'none'
        this.$store.commit("setMsgBoxState", false);
      },

      ChangeSearchValue() {
        this.showSearchField = !this.showSearchField
      },

      CleanInputFilter(){
        this.filter = ""
        this.newValue += 1
      },

      ApplyFilter(){
        this.msgListFiltered = this.msgList.filter(msg => {
          var filter = "";
          if(!msg)
            return false;
          const msgUpper = msg.toUpperCase();
          
          if(this.filter)
            filter = this.filter.toUpperCase();

        if (msgUpper.includes(filter))
          return msg;
        })
      },

      configDragble(){
        this.classToDrag = ".msgBoxContainer.msgBox";
        this.classToExpand = ".msgBoxContainer";
        this.fixMouseY = -10
        this.limitTop= 0
        this.limitBotom= 0
        this.limitRight= 0
        this.limitLeft= 0
      }
    },
    mounted() {
      this.configDragble();
     },

    beforeDestroy() {
      clearTimeout(taskGetSimulatorMessages);
    },    
  }
</script>

<style scoped>

.simulatior-message{
  z-index: 10;
}

.msgBoxContainer{  
  height: 200px;
  width: 600px;
  min-height: 70px;
  min-width: 500px;
  border: 2px solid black;    
  background-color: rgb(250, 244, 236);   
  border-radius: 4px;
}

.msxBoxTxtContainer{
  width: 602px;
  min-width: 400px;
  overflow-y: auto;    
}
.withoutSearch {
  height: calc(100% - 40px);
  width: 100%;
  min-height: 70px;
}
.withSearch {
  height: calc(100% - 55px);
  width: 100%;
  min-height: 70px;
}

.msgBoxHeader{
  background-color: black;  
  text-align: center;
  font-size: 0.9em;
  text-transform: uppercase;
  height: 25px;
  min-height: 25px;
  letter-spacing: 1px;
  cursor:"grab";
}
.waiting {
  color: white
}
.ready {
  color: #ff8d33;
}
.running {
  color: #00a39f;
}

.msgBoxTxt{
  font-size: 0.8em;
  height: auto;
  margin: 0px 5px 0px 5px;  
  overflow-wrap: break-word;
}

p:nth-child(odd) {
  background-color: rgb(247, 232, 212); 
}
.closeBoxBt{
  float: right;
  font-size: 0.8em;
  margin-right: 5px;  
  color: white;
}
.closeBoxBt:hover{
  cursor: pointer;
}
.searchBt {
  float: left;
  height: 18px;
  margin: 2px 5px;
}
.searchBt:hover {
  cursor: pointer;
}
.searchGroup {
  top: 30px;
  display: flex;
  height: 25px;
  max-height: 25px;
  font-size: 0.8em;
  letter-spacing: 1px;  
  background-color: black;
}

.searchTitle {
  color: white;
  margin-left: 5px;
}

.searchInput {
  margin-left: 5px;
  height: 23px;
  width: 40%;
  border-radius: 5px;
  border: 1px solid #ff5f00;  
}

.clearSearchInputFilterBt {
  margin-left: 10px;
  font-size: 1;
  color: white;
}

.clearSearchInputFilterBt:hover {
  cursor: pointer;
}

.slide-enter-active {
  animation: slide-in 2s ease;
}

.slide-leave-active {
  animation: slide-out 2s ease;
}

.expand{
  position: absolute;
  bottom: -6px;
  right: -6px;
  height: 12px;
  width: 12px;
  cursor: nw-resize;
}

.spaceDrag{
  cursor: move;
  z-index: 4;
}

@keyframes slide-in {
  from { transform: translateY(241px); }
  to { transform: translateY(0px); }
}

@keyframes slide-out {
  from { transform: translateY(0px); }
  to { transform: translateY(241px); }
}


@media only screen and (max-width: 624px) {
    .msgBoxContainer {  
      width: 96%;
      max-width: 96%;
      min-width: 96%;
    }
    .msgBoxTxt, .msxBoxTxtContainer {  
      width: 100%;
      max-width: 100%;
      min-width: 100%;
    }
  }

@media only screen and (max-width: 405px) {
    .msgBoxContainer {  
      width: 93%;
      max-width: 93%;
      min-width: 93%;
    }
  }

</style>

